/* This file is generated by createIcons.js any changes will be lost. */
import createIcon from '../createIcon';
export const Spinner2IconConfig = {
  name: 'Spinner2Icon',
  height: 1024,
  width: 1024,
  svgPath: 'M874.016 800.873c-92.647 92.658-220.631 149.984-362.016 149.984-282.77 0-512-229.23-512-512s229.23-512 512-512c153.639 0 291.458 67.691 385.303 174.857l-96.32 84.283c-5.595-6.377-11.401-12.615-17.458-18.667-72.523-72.528-168.955-112.473-271.525-112.473s-198.999 39.945-271.531 112.466c-72.521 72.535-112.469 168.965-112.469 271.534s39.947 198.999 112.469 271.529c72.53 72.526 168.962 112.471 271.531 112.471s198.999-39.945 271.529-112.471l154.805-61.198-64.318 151.685zM682.425 627.568c-23.333-23.333-15.424-42.425 17.575-42.425h264c51.666 0 60 9.001 60 60v264c0 33.001-19.093 40.907-42.425 17.575l-299.15-299.15z',
  yOffset: '64',
  xOffset: '',
  transform: 'rotate(180 0 512) scale(-1 1)'
};
export default createIcon(Spinner2IconConfig);
//# sourceMappingURL=spinner2-icon.js.map